import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import Toast from '../../../../core/components/core/Util/Toast/Toast';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import sleep from 'sleep-promise';

function List() {

    const pathFrontEnd = '/workplancategories/';
    const profileFilter = chooseProfileFilter();
    const [filterValues, setFilterValues] = useState({});
    const dispatch = useDispatch();
    const paths = useMemo(() => ({
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}workplancategories/delete`,
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllCompanies: config.endpoints.backend + 'companies/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpoint: config.endpoints.backend + 'workplancategories/getall'
    }),[]);

    async function updateSession(){
        await sleep(10);
        dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
    }

    useEffect(() => {
        async function update(){
            await updateSession();
        }    

        update();
    }, [filterValues])


    const clearFilters = (target, filterObject) => {
        const filterName = target['name'];
        if(filterName === 'pdc_company_id'){
            delete filterObject.pdc_entity_id;
            delete filterObject.pdc_project_id;
        }else if(filterName === 'pdc_entity_id'){
            delete filterObject.pdc_project_id;
        }
        return filterObject;
    }

    const handleChange = async (element) => {
        const target = element['target'];
        let filters = {...filterValues, [target['name']]: target['value']};
        filters = clearFilters(target,filters);
        setFilterValues(filters)
        
        await updateSession();
    }

    const filters = useMemo(() => ({
            validateOnChange: true,
            showGoBackButton: false,
            showSubmitButton: false,
            update_key: `${filterValues.pdc_company_id}-${filterValues.pdc_entity_id}-${filterValues.pdc_project_id}`,
            handleSubmit: loadData,
            fields: [
                !profileFilter.pdc_company_id && !profileFilter.pdc_entity_id && !profileFilter.pdc_project_ids && {
                    name: 'pdc_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    handleChange,
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 3,
                },
                !profileFilter.pdc_entity_id && !profileFilter.pdc_entity_id && !profileFilter.pdc_project_ids && {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    handleChange,
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_company_id: !!filterValues.pdc_company_id ? filterValues.pdc_company_id : profileFilter.pdc_company_id 
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 3,
                },
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    handleChange,
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_company_id: !!filterValues.pdc_company_id ? filterValues.pdc_company_id : profileFilter.pdc_company_id, 
                                pdc_entity_id: !!filterValues.pdc_entity_id ? filterValues.pdc_entity_id : profileFilter.pdc_entity_id 
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 3,
                }
            ],
            values: {
                pdc_company_id: filterValues.pdc_company_id,
                pdc_entity_id: filterValues.pdc_entity_id,
                pdc_project_id: filterValues.pdc_project_id
            }
    }), [paths, filterValues]);

    const list = useMemo(() => {
        let list = {
                labelTitle: 'Lista de categorias do plano de trabalho',
                labelTitleButtonAdd: 'Incluir nova  categoria do plano de trabalho',
                fieldsShowOnDelete: ['project_name','description'],
                showPrintButtons: true,
                formFilters: !profileFilter.pdc_project_ids ? filters : null, 
                filter: {
                    ...profileFilter,
                    pdc_company_id: !!filterValues.pdc_company_id ? filterValues.pdc_company_id : profileFilter.pdc_company_id,
                    pdc_entity_id: !!filterValues.pdc_entity_id ? filterValues.pdc_entity_id : profileFilter.pdc_entity_id,
                    pdc_project_id: filterValues.pdc_project_id,
                },
                columns: [
                    {
                        name: 'entity_name',
                        label: 'Entidade'
                    },
                    {
                        name: 'project_name',
                        label: 'Projeto'
                    },
                    {
                        name: 'description',
                        label: 'Categoria'
                    }
                ]
            };

            list = { ...list, ...paths };

            return list;
    }, [paths, filters]);

    const content = useMemo(() => (
        <CustomList list={{ ...list, ...paths }} />
    ), [list, paths, filters]);

    const customListContainer = useMemo(() => (
        <CustomListContainer
            pathAdd={paths.pathAdd}
            labelTitle={list.labelTitle}
            labelTitleButtonAdd={list.labelTitleButtonAdd}
            content={content}
        />
    ), [content, paths, filters, list]);

    return (
        <div>
            {customListContainer}
        </div>
    );
}
export default List;
